import React from 'react'
import { ListPanel } from '@sukiai/components'
import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE } from '../../lib/constants'
import { getListPanelMarginProps } from '../../lib/helpers'

const PatientsListContainer = ({
  type,
  loading,
  patientsList,
  count,
  openNoteTypeSelection,
  handleModeChange,
  handleAddPatientPrompt,
  handleDeletePatientClick,
  fullHeight
}) => {
  const isSmallWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.SMALL_LIST_PANEL_WIDTH})`
  })

  const isCrampedWindow = useMediaQuery({
    query: `(max-width: ${RESPONSIVE.CRAMPED_LIST_PANEL_WIDTH})`
  })

  const marginProps = getListPanelMarginProps()
  return (
    <ListPanel
      type={type}
      loading={loading}
      patientsList={patientsList}
      count={count}
      openNoteTypeSelection={openNoteTypeSelection}
      handleModeChange={handleModeChange}
      handleAddPatientPrompt={handleAddPatientPrompt}
      handleDeletePatientClick={handleDeletePatientClick}
      fullHeight={fullHeight}
      isSmallWindow={isSmallWindow}
      isCrampedWindow={isCrampedWindow}
      {...marginProps}
    />
  )
}

export default PatientsListContainer
